import React from 'react';
import { ArrowRightIcon, SparklesIcon, TrendingUpIcon, TargetIcon, BarChart3Icon } from 'lucide-react';
const Home3Page = () => {
  return <div className="min-h-screen bg-white" data-id="element-3292">
      {/* Hero Section */}
      <section className="relative py-24 md:py-32 overflow-hidden" data-id="element-3293">
        {/* Subtle background gradient */}
        <div className="absolute inset-0 bg-gradient-to-br from-gray-50 via-white to-gray-50" data-id="element-3294"></div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-3295">
          <div className="max-w-4xl mx-auto text-center" data-id="element-3296">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-gray-900 mb-8 leading-tight tracking-tight" data-id="element-3297">
              World's leading AI-powered eCommerce and Digital Experiences
            </h1>

            <p className="text-xl md:text-2xl text-gray-600 mb-12 leading-relaxed max-w-3xl mx-auto" data-id="element-3298">
              Shopilots.com empowers brands and teams with everything they need
              to build, personalize, test and optimize online experiences that
              drive growth — fast, smart, and beautifully designed.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-3299">
              <a href="https://chat.shopilots.com/signup?product=shopilots" className="inline-flex items-center justify-center px-8 py-4 bg-gray-900 text-white text-lg font-semibold rounded-lg hover:bg-gray-800 transition-all duration-200 shadow-lg hover:shadow-xl" data-id="element-3300">
                Get Started
                <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-3301" />
              </a>
              <a href="mailto:info@shopilots.com?subject=I%20want%20to%20talk%20to%20sales" className="inline-flex items-center justify-center px-8 py-4 bg-white text-gray-900 text-lg font-semibold rounded-lg border-2 border-gray-300 hover:border-gray-900 transition-all duration-200" data-id="element-3302">
                Contact Sales
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-24 bg-gray-50" data-id="element-3303">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3304">
          <div className="grid md:grid-cols-3 gap-12" data-id="element-3305">
            {/* Feature 1 */}
            <div className="bg-white rounded-2xl p-10 shadow-sm border border-gray-200 hover:shadow-md transition-shadow" data-id="element-3306">
              <div className="w-14 h-14 bg-gray-900 rounded-xl flex items-center justify-center mb-6" data-id="element-3307">
                <SparklesIcon className="h-7 w-7 text-white" data-id="element-3308" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-3309">
                Create with Confidence
              </h2>
              <p className="text-gray-600 leading-relaxed" data-id="element-3310">
                From stunning product pages to dynamic experiences,
                Shopilots.com gives your team the tools to create content, test
                ideas, and launch with speed and precision.
              </p>
            </div>

            {/* Feature 2 */}
            <div className="bg-white rounded-2xl p-10 shadow-sm border border-gray-200 hover:shadow-md transition-shadow" data-id="element-3311">
              <div className="w-14 h-14 bg-gray-900 rounded-xl flex items-center justify-center mb-6" data-id="element-3312">
                <TargetIcon className="h-7 w-7 text-white" data-id="element-3313" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-3314">
                Personalize & Optimize
              </h2>
              <p className="text-gray-600 leading-relaxed" data-id="element-3315">
                Deliver tailored experiences with integrated AI-driven workflows
                that improve engagement, conversions and customer satisfaction.
              </p>
            </div>

            {/* Feature 3 */}
            <div className="bg-white rounded-2xl p-10 shadow-sm border border-gray-200 hover:shadow-md transition-shadow" data-id="element-3316">
              <div className="w-14 h-14 bg-gray-900 rounded-xl flex items-center justify-center mb-6" data-id="element-3317">
                <BarChart3Icon className="h-7 w-7 text-white" data-id="element-3318" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-3319">
                Measure Real Impact
              </h2>
              <p className="text-gray-600 leading-relaxed" data-id="element-3320">
                Track performance, experiment with confidence, and prove
                business outcomes with insight-rich analytics and optimization
                tools.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-20 bg-white" data-id="element-3321">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3322">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-3323">
            <div data-id="element-3324">
              <div className="text-5xl font-bold text-gray-900 mb-2" data-id="element-3325">+25%</div>
              <div className="text-gray-600 font-medium" data-id="element-3326">
                Conversion Increase
              </div>
            </div>
            <div data-id="element-3327">
              <div className="text-5xl font-bold text-gray-900 mb-2" data-id="element-3328">90%</div>
              <div className="text-gray-600 font-medium" data-id="element-3329">Cost Reduction</div>
            </div>
            <div data-id="element-3330">
              <div className="text-5xl font-bold text-gray-900 mb-2" data-id="element-3331">10M+</div>
              <div className="text-gray-600 font-medium" data-id="element-3332">Conversations</div>
            </div>
            <div data-id="element-3333">
              <div className="text-5xl font-bold text-gray-900 mb-2" data-id="element-3334">
                1,500+
              </div>
              <div className="text-gray-600 font-medium" data-id="element-3335">Happy Customers</div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-24 bg-gray-50" data-id="element-3336">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3337">
          <div className="max-w-3xl mb-16" data-id="element-3338">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-3339">
              Everything you need to grow
            </h2>
            <p className="text-xl text-gray-600" data-id="element-3340">
              Powerful tools designed for modern eCommerce teams
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-3341">
            <div className="bg-white rounded-xl p-8 border border-gray-200" data-id="element-3342">
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-3343">
                AI-Powered Shopping Assistants
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-3344">
                Deploy intelligent AI agents that understand your products and
                guide customers to purchase 24/7.
              </p>
              <ul className="space-y-2" data-id="element-3345">
                <li className="flex items-start gap-2 text-sm text-gray-600" data-id="element-3346">
                  <span className="text-green-600 mt-1" data-id="element-3347">✓</span>
                  <span data-id="element-3348">Product recommendations</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-gray-600" data-id="element-3349">
                  <span className="text-green-600 mt-1" data-id="element-3350">✓</span>
                  <span data-id="element-3351">Cart abandonment recovery</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-gray-600" data-id="element-3352">
                  <span className="text-green-600 mt-1" data-id="element-3353">✓</span>
                  <span data-id="element-3354">Multi-channel deployment</span>
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-xl p-8 border border-gray-200" data-id="element-3355">
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-3356">
                Personalization Engine
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-3357">
                Deliver unique experiences to every customer based on behavior,
                preferences, and intent.
              </p>
              <ul className="space-y-2" data-id="element-3358">
                <li className="flex items-start gap-2 text-sm text-gray-600" data-id="element-3359">
                  <span className="text-green-600 mt-1" data-id="element-3360">✓</span>
                  <span data-id="element-3361">Dynamic content</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-gray-600" data-id="element-3362">
                  <span className="text-green-600 mt-1" data-id="element-3363">✓</span>
                  <span data-id="element-3364">Behavioral targeting</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-gray-600" data-id="element-3365">
                  <span className="text-green-600 mt-1" data-id="element-3366">✓</span>
                  <span data-id="element-3367">A/B testing</span>
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-xl p-8 border border-gray-200" data-id="element-3368">
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-3369">
                Analytics & Insights
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-3370">
                Make data-driven decisions with comprehensive analytics and
                real-time reporting.
              </p>
              <ul className="space-y-2" data-id="element-3371">
                <li className="flex items-start gap-2 text-sm text-gray-600" data-id="element-3372">
                  <span className="text-green-600 mt-1" data-id="element-3373">✓</span>
                  <span data-id="element-3374">Conversion tracking</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-gray-600" data-id="element-3375">
                  <span className="text-green-600 mt-1" data-id="element-3376">✓</span>
                  <span data-id="element-3377">Customer journey mapping</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-gray-600" data-id="element-3378">
                  <span className="text-green-600 mt-1" data-id="element-3379">✓</span>
                  <span data-id="element-3380">Performance dashboards</span>
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-xl p-8 border border-gray-200" data-id="element-3381">
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-3382">
                Seamless Integrations
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-3383">
                Connect with your existing tools and platforms for a unified
                workflow.
              </p>
              <ul className="space-y-2" data-id="element-3384">
                <li className="flex items-start gap-2 text-sm text-gray-600" data-id="element-3385">
                  <span className="text-green-600 mt-1" data-id="element-3386">✓</span>
                  <span data-id="element-3387">Shopify, WooCommerce, Magento</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-gray-600" data-id="element-3388">
                  <span className="text-green-600 mt-1" data-id="element-3389">✓</span>
                  <span data-id="element-3390">WhatsApp, Instagram, Telegram</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-gray-600" data-id="element-3391">
                  <span className="text-green-600 mt-1" data-id="element-3392">✓</span>
                  <span data-id="element-3393">CRM and analytics tools</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Social Proof */}
      <section className="py-16 bg-white border-y border-gray-200" data-id="element-3394">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3395">
          <p className="text-center text-sm font-medium text-gray-500 uppercase tracking-wide mb-8" data-id="element-3396">
            Trusted by leading platforms
          </p>
          <div className="flex flex-wrap justify-center items-center gap-12 opacity-40 grayscale" data-id="element-3397">
            <img src="https://cdn.worldvectorlogo.com/logos/shopify.svg" alt="Shopify" className="h-8" data-id="element-3398" />
            <img src="https://cdn.worldvectorlogo.com/logos/woocommerce.svg" alt="WooCommerce" className="h-8" data-id="element-3399" />
            <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" className="h-8" data-id="element-3400" />
            <img src="https://cdn.worldvectorlogo.com/logos/telegram-1.svg" alt="Telegram" className="h-8" data-id="element-3401" />
            <img src="https://cdn.worldvectorlogo.com/logos/salesforce-2.svg" alt="Salesforce" className="h-8" data-id="element-3402" />
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-gray-900 text-white" data-id="element-3403">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-3404">
          <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-3405">
            Ready to transform your digital experience?
          </h2>
          <p className="text-xl text-gray-400 mb-10" data-id="element-3406">
            Join 1,500+ brands growing with Shopilots
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-3407">
            <a href="https://chat.shopilots.com/signup?product=shopilots" className="inline-flex items-center justify-center px-10 py-4 bg-white text-gray-900 text-lg font-semibold rounded-lg hover:bg-gray-100 transition-all duration-200" data-id="element-3408">
              Get Started Free
              <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-3409" />
            </a>
            <a href="mailto:info@shopilots.com?subject=I%20want%20to%20book%20a%20demo" className="inline-flex items-center justify-center px-10 py-4 bg-transparent text-white text-lg font-semibold rounded-lg border-2 border-gray-700 hover:border-white transition-all duration-200" data-id="element-3410">
              Book a Demo
            </a>
          </div>

          <p className="text-sm text-gray-500 mt-8" data-id="element-3411">
            30-day free trial · No credit card required · Cancel anytime
          </p>
        </div>
      </section>
    </div>;
};
export default Home3Page;